import React, { useContext, useState, useEffect } from 'react';
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from '../../Context/ConfigContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { currentDateAndTime } from '../../Constants/constants';
import ViewOnlyHeader from '../../Layout/ViewOnlyHeader';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const InductionProcess = () => {
    const query = useQuery();
    const [companyId, setCompanyId] = useState(query.get("c_id"));
    const [mobileNumber, setMobileNumber] = useState(query.get("mo_n"));
    const { apiURL, apiHeaderFile, apiHeaderJSON } = useContext(ConfigContext);
    const [policyRows, setPolicyRows] = useState([]);
    const [policyIndex, setPolicyIndex] = useState(0);
    const [animation, setAnimation] = useState("");
    const [percentage, setPercentage] = useState(0);
    const [checkedPolicy, setCheckedPolicy] = useState(false);
    const [companyInfo, setCompanyInfo] = useState({});
    const [acceptRejectBtn, setAcceptRejectBtn] = useState(false);
    const [isPage404, setIsPage404] = useState(false);
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getList = () => {
        setLoading(true);
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Home/GetAssignedCompanyPolicyList`, {
                params: {
                    company_id: companyId,
                    guest_employee_mobile_number: mobileNumber,
                    date: currentDateAndTime(),
                },
                headers,
            })
            .then((response) => {
                var data = response.data;
                console.log(data);
                if (response.data.success === true) {
                    setPolicyRows(data?.employee_assigned_policies);
                    // setPolicyIndex(data?.employee_assigned_policies[0]?.company_policy_status === "1" ? 0 )
                    setPercentage(data?.percent_progress);
                    // setCompanyInfo(data?.company_info[0]);
                    // setAcceptRejectBtn(data?.button_hide);
                    if (data?.employee_assigned_policies[policyIndex + 1]?.company_policy_status === "1") {
                        setCheckedPolicy({
                            company_policy_id: data?.employee_assigned_policies[policyIndex + 1]?.company_policy_id,
                            company_policy_status: data?.employee_assigned_policies[policyIndex + 1]?.company_policy_status
                        });
                    }
                    
                        // if (response?.data?.process_done) {
                        //     localStorage.removeItem("token_emp");
                        //     localStorage.removeItem("company_id_emp");
                        //     localStorage.removeItem("employee_id_emp");
                        //     localStorage.removeItem("employee_code_emp");
                        //     localStorage.removeItem("induction_status");
                        //     window.location.href = '/'
                        // }
                   
                    nextPage();
                    setIsPage404(false);
                    setMessage(false);
                    setLoading(false);
                } else {
                    if (data?.message === "This link is expired.") {
                        setIsPage404("2");
                    }
                    else {
                        setIsPage404("1");
                        setMessage(data?.message);
                    }
                    setLoading(false);
                }
            }).catch((error) => {
                // Swal.fire({
                //     title: `<strong>Failed</strong>`,
                //     text: "Opps...! Something went wrong !!",
                //     icon: 'error',
                //     showConfirmButton: true,
                //     allowOutsideClick: false
                // })
                setLoading(false);
            });
    };
    useEffect(() => {
        getList();
        setIsPage404(false);
    }, []);

    const nextPage = () => {
        const errors = {};
        if (policyIndex < policyRows?.length - 1 && checkedPolicy) {
            // setPolicyIndex(policyIndex + 1);
            if (policyRows[policyIndex + 1]?.company_policy_status === "1") {
                setCheckedPolicy({
                    company_policy_id: policyRows[policyIndex + 1]?.company_policy_id,
                    company_policy_status: policyRows[policyIndex + 1]?.company_policy_status,
                });
            } else {
                setCheckedPolicy(false);
            }

            setAnimation("slide-out-prev");
            setTimeout(() => {
                setPolicyIndex(policyIndex + 1);
                setAnimation("slide-in-next");
            }, 100);
        }
        else if (!checkedPolicy?.includes(policyRows[policyIndex]?.policy_id)) {
            // errors.checkedPolicy="Please agree ";
        }


    }
    const prevPage = () => {
        if (policyIndex > 0) {
            // setPolicyIndex(policyIndex - 1);
            if (policyRows[policyIndex - 1]?.company_policy_status === "1") {
                setCheckedPolicy({
                    company_policy_id: policyRows[policyIndex - 1]?.company_policy_id,
                    company_policy_status: policyRows[policyIndex - 1]?.company_policy_status,
                });
            } else {
                setCheckedPolicy(false);
            }
            setAnimation("slide-out-next");
            setTimeout(() => {
                setPolicyIndex(policyIndex - 1);
                setAnimation("slide-in-prev");
            }, 100);
            // const percente= Math.round(((policyIndex-1)/policyRows?.length)*100);
            // setPercentage(percente);
        }
    }
    // console.log(checkedPolicy, policyRows[policyIndex]?.policy_id, checkedPolicy?.includes(policyRows[policyIndex]?.policy_id));
    const handleCheckboxChange = (row) => {

        // const checked = [...checkedPolicy];

        // if (checked.includes(id)) {
        //     checked.splice(
        //         checked.indexOf(id),
        //         1
        //     );
        //     if (checkedPolicy?.length > 0) {
        //     const percente= Math.round(((checkedPolicy?.length-1)/policyRows?.length)*100);
        //     console.log("Minus",percente);
        //     setPercentage(percente);
        //     }
        // } else {
        //     checked.push(id);
        //     const percente= Math.round(((checkedPolicy?.length+1)/policyRows?.length)*100);
        //     console.log("Sum",percente);
        //     setPercentage(percente);
        // }
        if (checkedPolicy?.employee_induction_id) {
            setCheckedPolicy(false);
        }
        else {
            setCheckedPolicy({
                employee_induction_id: row?.employee_induction_id,
                company_policy_status: row?.company_policy_status,
            });
        }



    };
    const handleAccept = (type) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to accept this policy?`,
            icon: 'warning',
            // input: 'text',
            // inputPlaceholder: 'Remark (Optional)',
            showCancelButton: true,
            confirmButtonText: 'Yes, Accept!',
            cancelButtonText: 'No!',
            // inputValidator: (value) => {
            //     if (!value) {
            //         return 'Remark cannot be empty';
            //     }
            // },
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    employee_induction_id: checkedPolicy?.employee_induction_id,
                    company_policy_status: "1",
                    date: currentDateAndTime()
                }
                if (type === "1") {
                    data.final_submit = "1";
                }
                const headers = apiHeaderJSON;
                console.log(data);
                axios
                    .post(`${apiURL}Home/AcceptRejectCompanyPolicy`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("AcceptRejectCompanyPolicy ~ response =======>>>", response);
                        if (success === true) {
                            // setAcceptRejectBtn(true);
                            

                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            }).then((result) => {
                                if (result.isConfirmed && response?.data?.process_done) {
                                    localStorage.removeItem("token_emp");
                                    localStorage.removeItem("company_id_emp");
                                    localStorage.removeItem("employee_id_emp");
                                    localStorage.removeItem("employee_code_emp");
                                    localStorage.removeItem("induction_status");
                                    window.location.href = '/'
                                }
                                setCheckedPolicy(false);
                                getList();
                            });
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            });
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }
    const handleReject = () => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to reject this Appointment Letter?`,
            icon: 'warning',
            reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Remark*',
            showCancelButton: true,
            confirmButtonText: 'Yes, Reject!',
            cancelButtonText: 'No!',
            inputValidator: (value) => {
                if (!value) {
                    return 'Remark cannot be empty';
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    request_type: 2,
                    remark: result?.value,
                    date: currentDateAndTime()
                }
                const headers = apiHeaderJSON;
                console.log(data);
                axios
                    .post(`${apiURL}Home/AcceptRejectAppointmentLetter`, data, {
                        params: {
                            company_id: companyId,
                            guest_employee_mobile_number: mobileNumber
                        },
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleAcceopt ~ response =======>>>", response);
                        if (success === true) {
                            setAcceptRejectBtn(true);
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.success === true ? 'Success' : 'Failed'
                                    }</strong>`,
                                text: response.data.message,
                                icon: response.data.success === true ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick: false
                            })
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    return (
        <>
            {!isPage404 ?
                !loading ?
                    <div class="main-content" >
                        {/* <ViewOnlyHeader /> */}
                        <div class="page-content" style={{ paddingTop: "1rem" }} >
                            <div className="container-fluid">
                                <br />
                                <h4 className='font-semibold '>Policy and Agreement</h4>
                                <div className="md-card">
                                    <div className="card-body">
                                        <div className=' md-p-3 md-mx-3'>
                                            <div className="mb-4 m-auto bg-white policyBox p-3 overflow-hidden rounded-2 grayBlurShadow"
                                            // style={{ width: "70%"}}
                                            >
                                                <div
                                                    id='policy'
                                                    className={`policy-container ${animation} `}
                                                    key={policyRows[policyIndex]?.letter_url}
                                                >
                                                    <h3 className="text-center">{policyRows[policyIndex]?.company_letter_title}</h3>
                                                    <div
                                                        className={`m-auto rounded-3 overflow-hidden ${policyRows[policyIndex]?.company_policy_content_type === "1" ? "policy-iframe" : "policy-iframe-text"} `}
                                                        style={{
                                                            width: "100%",
                                                            // height: "120vh",
                                                            border: "1px solid #ccc",
                                                        }}
                                                    >
                                                        {policyRows[policyIndex]?.company_policy_content_type === "1" ?
                                                            <iframe
                                                                src={policyRows[policyIndex]?.company_policy_document_url}
                                                                title="PDF Viewer"
                                                                style={{ width: "100%", height: "100%" }}
                                                                frameBorder="0"
                                                            >
                                                                This browser does not support embedded files.
                                                            </iframe> :
                                                            <div className=' p-3 overflow-y-scroll' style={{ width: "100%", height: "100%" }}
                                                                dangerouslySetInnerHTML={{ __html: policyRows[policyIndex]?.company_policy_content }}
                                                            />
                                                        }


                                                    </div>
                                                </div>
                                                <div className="progress animated-progress custom-progress progress-label mt-3">
                                                    <div
                                                        className="progress-bar bg-link"
                                                        role="progressbar"
                                                        style={{ width: `${percentage}%` }}
                                                        aria-valuenow={percentage}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                    >
                                                        <div className="label">{percentage}%</div>
                                                    </div>
                                                </div>
                                                <div className=' d-flex align-items-center gap-2 mt-2'>
                                                    <input type="checkbox"
                                                        className=' cursorPointer'
                                                        checked={checkedPolicy || policyRows[policyIndex]?.company_policy_status === "1"}
                                                        onChange={(e) => handleCheckboxChange(policyRows[policyIndex])}
                                                    />
                                                    <p className='mb-0'>I agree to the Terms & Conditions.</p>
                                                </div>

                                                <div className=" mt-2">
                                                <div className=" text-center fw-bold ">
                                                    {`${policyIndex+1}/${policyRows?.length}`}
                                                </div>
                                                    <div>
                                                        <div>
                                                            <div className="d-flex justify-content-between">
                                                                <button
                                                                    disabled={policyIndex === 0}
                                                                    type="button"
                                                                    onClick={() => prevPage()}
                                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                                >
                                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                                    Previous
                                                                </button>
                                                                {/* {policyIndex < policyRows?.length - 1 && ( */}
                                                                <button
                                                                    disabled={(!checkedPolicy) || (policyIndex >= policyRows?.length - 1)}
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (policyRows[policyIndex]?.company_policy_status === "1") {
                                                                            nextPage();
                                                                        }
                                                                        else {
                                                                            handleAccept();
                                                                        }

                                                                    }}
                                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                                >
                                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                                    Next
                                                                </button>
                                                                {/* )} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {policyIndex === policyRows?.length - 1 ?
                                                    <div className=' d-flex align-items-center justify-content-end mt-3'>
                                                        <button
                                                            disabled={acceptRejectBtn}
                                                            // style={{ marginRight: "10px" }}
                                                            onClick={() => { handleAccept("1") }}
                                                            className={`btn btn-success btn-label waves-effect waves-light float-right`}
                                                        >
                                                            <i
                                                                className={`ri-mail-check-line label-icon align-middle fs-16 ms-2`}
                                                            />
                                                            {'Submit'}
                                                        </button>
                                                    </div> : null
                                                }
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div> :
                isPage404 === "2" ?
                    <div>
                        <div className="auth-page-wrapper bg-white py-1 d-flex justify-content-center align-items-center min-vh-100">
                            {/* auth-page content */}
                            <div className="auth-page-content overflow-hidden p-0">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-xl-7 col-lg-8">
                                            <div className="text-center">
                                                <img src="assets/images/link_expired.png" alt="error img" className="img-fluid" />
                                                <div className="mt-3">
                                                    <h3 className="text-uppercase">❌ The link you followed has expired.</h3>
                                                    {/* <p className="text-muted mb-4"></p> */}
                                                </div>
                                            </div>
                                        </div>{/* end col */}
                                    </div>
                                    {/* end row */}
                                </div>
                                {/* end container */}
                            </div>
                            {/* end auth-page content */}
                        </div>

                    </div> :
                    <div>
                        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                            {/* auth-page content */}
                            <div className="auth-page-content overflow-hidden p-0">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-xl-7 col-lg-8">
                                            <div className="text-center">
                                                <img src="assets/images/error400-cover.png" alt="error img" className="img-fluid" />
                                                <div className="mt-3">
                                                    <h3 className="text-uppercase">{message || `Sorry, Page not Found 😭`}</h3>
                                                    <p className="text-muted mb-4">The page you are looking for not available!</p>
                                                    {/* <NavLink to={'/'} className="btn btn-success"><i className="mdi mdi-home me-1" />Back to home</NavLink> */}
                                                </div>
                                            </div>
                                        </div>{/* end col */}
                                    </div>
                                    {/* end row */}
                                </div>
                                {/* end container */}
                            </div>
                            {/* end auth-page content */}
                        </div>
                    </div>
            }
        </>
    );
}

export default InductionProcess;

